//@flow
import { connect } from 'react-redux';
import { CommonActions } from '@react-navigation/native';
import SuccessPage from '../../../components/SuccessPage/SuccessPage';
import { errorSelector } from '../../../modules/LoadingStatus';
import theme from '../../../theme-config';
import I18n from '../../../lib/i18n';

import type { StateProps, DispatchProps } from '../../../components/SuccessPage/SuccessPage';
import type { StateType } from '../../../modules/reducers';
import Navigation from '../../../lib/navigation';

const mapStateToProps = (state: StateType): StateProps => ({
  error: errorSelector(state, 'resetPasswordConfirmation'),
  successImage: theme.successPhoneImage,
  successTitle: I18n.t('Login.ResetPasswordConfirmation.successTitle'),
  confirmButtonText: I18n.t('Login.ResetPasswordConfirmation.confirmButton'),
  withGradient: true,
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  confirmButtonAction: () => Navigation.dispatch(CommonActions.navigate({ name: 'auth' })),
});

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);
